import { render, staticRenderFns } from "./searchColor.vue?vue&type=template&id=55a16b9c&scoped=true"
import script from "./searchColor.vue?vue&type=script&lang=js"
export * from "./searchColor.vue?vue&type=script&lang=js"
import style0 from "./searchColor.vue?vue&type=style&index=0&id=55a16b9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a16b9c",
  null
  
)

export default component.exports